import { ProjectContext } from '../contexts/ProjectContext';
import { useContext } from 'react';

export default function useProject() {
  return useContext(ProjectContext);
}
